/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { VideoIcon, UnitIcon, UnitRightIcon, TimesIcon } from '@/icons';
import { useTranslation } from 'react-i18next';
import MediaPlayer, {
  mediaTypes,
} from '@/components/media-player/mediaplayer';
import './BookVideos.scss';
import { PageCanvasService } from '@/database/smartBookModelService';

interface BookVideosProps {
  bookId: number;
  bookVideos: any[];
}

const BookVideos: React.FC<BookVideosProps> = ({ bookId, bookVideos }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'book_detail' });
  
  const [activeUnit, setActiveUnit] = useState<any | null>(null);
  const [selectedVideo, setSelectedVideo] = useState<any | null>(null);
  useEffect(() => {
    if (bookVideos.length > 0) {
      const firstUnitWithVideos = bookVideos.find(
        (unit) => unit.items?.length > 0,
      );
      if (firstUnitWithVideos) {
        setActiveUnit(firstUnitWithVideos);
      }
    }
  }, [bookVideos]);

  const openVideo = async (video: any) => {

    const activityPath = await PageCanvasService.getActivityPath(
      bookId,
      video.id,
      video,
    );

    setSelectedVideo({ ...video, path: activityPath });
  };

  const closeVideo = async () => {
    setSelectedVideo(null);
  };

  if (!activeUnit) return null;

  return (
    <div className="book-video-wrapper">
      <div className="book-video-container">
        <div className="book-video-sidebar">
          <div className="sidebar-header">
            <UnitIcon className="unit-icon" />
            <span>{t('units')}</span>
          </div>

          <div className="unit-list">
            {bookVideos.map((unit) => {
              if (!unit.items?.length) return null;

              return (
                <div
                  key={unit.id}
                  className={`unit-item ${activeUnit.id === unit.id ? 'active' : ''}`}
                  onClick={() => setActiveUnit(unit)}
                >
                  <div className="unit-info">
                    <div className="unit-icon-wrapper">
                      <UnitIcon className="unit-icon" />
                    </div>
                    <div className="unit-text">
                      <span className="unit-title">{unit.title}</span>
                      <div className="unit-meta">
                        <span className="unit-count">
                          {unit.items.length} videos
                        </span>
                      </div>
                    </div>
                  </div>
                  <UnitRightIcon className="arrow-icon" />
                </div>
              );
            })}
          </div>
        </div>

        <div className="book-video-content">
          <div className="content-main">
            <div className="content-header">
              <div className="header-title">
                <VideoIcon className="video-icon" color={undefined} />
                <h2>{activeUnit.title}</h2>
              </div>
              <span className="video-count">
                {activeUnit.items.length} Videos
              </span>
            </div>

            <div className="video-grid">
              {activeUnit.items.map((video: any) => (
                <div
                  key={video.id}
                  className={`video-card ${selectedVideo?.id === video.id ? 'active' : ''}`}
                  onClick={() => openVideo(video)}
                >
                  <div className="video-thumbnail">
                    <VideoIcon className="video-icon" color={undefined} />
                  </div>
                  <div className="video-info">
                    <span className="video-title">{video.title}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {selectedVideo && (
            <div className="content-player">
              <div className="player-header">
                <span className="now-playing">{selectedVideo?.title}</span>
                <button className="close-button" onClick={() => closeVideo()}>
                  <TimesIcon className={undefined} />
                </button>
              </div>
              <MediaPlayer url={selectedVideo.path} type={mediaTypes.video} transcript={undefined} title={undefined} footer={undefined} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BookVideos;
